namespace pixi_ui.component {
    import Sprite = PIXI.Sprite;
    import Texture = PIXI.Texture;

    export class Rect implements IComponent {
        public color: number = 0xffffff;
        public alpha: number = 1.0;
        public sprite: Sprite;

        constructor(color: number, alpha: number) {
            this.color = color;
            this.alpha = alpha;
            this.sprite = new Sprite(Texture.WHITE);
        }

        public attach(element: Element): void {
            this.sprite.tint = this.color;
            this.sprite.alpha = this.alpha;
            this.sprite.width = element.contentWidth;
            this.sprite.height = element.contentHeight;
            element.addChild(this.sprite);
        }

        public detach(element: Element): void {
            element.removeChild(this.sprite);
        }

        public resize(element: Element): void {
            this.sprite.width = element.contentWidth;
            this.sprite.height = element.contentHeight;
        }
    }
}
